import { Col, Row } from "react-bootstrap";
import styles from "./Signup.module.scss";

export default function SignupFooter() {
  return (
    <div className={styles.includedPlan}>
      <p>Included Features</p>
      <Row>
        <Col xs={4}>
          <ul>
            <li>No Activation Fee</li>
            <li>Unlimited Documents</li>
            <li>Discovery Responses</li>
            <li>Propound Discovery</li>
          </ul>
        </Col>
        <Col xs={4}>
          <ul>
            <li>Interrogatories</li>
            <li>RFAs/RTAs</li>
            <li>RFPs/RTPs/DFPs</li>
            <li>Firm Standardization</li>
          </ul>
        </Col>
        <Col xs={4}>
          <ul>
            <li>Free Training</li>
            <li>Automatic Formatting</li>
            <li>Automatic Objections</li>
            <li>Tailored Objections</li>
          </ul>
        </Col>
      </Row>
    </div>
  );
}
